import React from 'react';
import { CheckboxInput } from 'ui-builder';
import { RoadmapCheckboxesToggleWrapper } from 'feature-toggle';

export function PortalRoadmapCheckbox() {
  return (
    <RoadmapCheckboxesToggleWrapper>
      <CheckboxInput source="isIncludedToRoadmap" label="Portal Roadmap" />
    </RoadmapCheckboxesToggleWrapper>
  );
}
